const LOGIN_ROUTE = '/login'
const LOGIN_MF_PAYMENT_ROUTE = '/login?redirect=L2FwcC1wYXltZW50&clientId=conecta-web'

module.exports = {
    LOGIN_ROUTE,
    LOGIN_MF_PAYMENT_ROUTE
}